<template lang="pug">
    section.is-scrollable
        div.content(v-if="isLoading")
            div.stripe.long-stripe
            div.stripe.medium-long-stripe
            div.stripe.long-stripe
            div.stripe.medium-long-stripe
            div.stripe.long-stripe
            div.stripe.medium-long-stripe
        ul(v-else)
            li.l-flex-row--between.shared-account(v-for="sharedAccount of sharedAccountsList" :key="sharedAccount.id")
                div.shared-account-info
                    div.shared-account-id {{ sharedAccount.id }}
                    div.shared-account-label(:title="sharedAccount.label") {{ sharedAccount.label }}
                div.shared-account-action(v-if="itemStateVisible") 
                    div.onoffswitch(:class="{'ui-disabled': disableInput}")
                        input(
                            :id="`switch-sharing-${sharedAccount.id}`"
                            :name="`switch-sharing-${sharedAccount.id}`"
                            class="onoffswitch-checkbox"
                            type="checkbox"
                            :checked="sharedAccount.status === 'active'"
                            :true-value="'active'"
                            :false-value="'inactive'"
                            :value="sharedAccount.status"
                            @change.prevent="updateValue(sharedAccount.id, $event.target.checked)"
                        )
                        label(class="onoffswitch-label" :for="`switch-sharing-${sharedAccount.id}`")
</template>

<script>
// Avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { isEmpty } from 'lodash'

export default {
    name: 'SharingAudiences',

    mounted() {
        if (isEmpty(this.sharedAudiences[this.audienceSelectedId])) {
            this.retrieveAudienceSharing()
        }
    },
    watch: {
        // this is triggered when user updates the list of sharing accounts in settings, so we also do update the list here
        sharingSettings: {
            handler: function() {
                this.retrieveAudienceSharing()
            },
            deep: true
        },

        audienceSelectedId: {
            handler: function() {
                if (!this.sharingIsUpToDate) this.retrieveAudienceSharing()
            }
        }
    },

    computed: {
        // Call to state
        ...mapState('account', {
            userRole: state => state.userRole
        }),
        ...mapState('data/settings', {
            sharingSettings: state => state.sharing
        }),
        ...mapState('data/sharedAudience', {
            isLoading: state => state.isLoading,
            sharedAudiences: state => state.list,
            isProcessing: state => state.isProcessing
        }),
        ...mapState('ui/monitoring', {
            audienceSelectedId: state => state.selectedRowId
        }),
        ...mapGetters('account', ['getUserAccess', 'getIsMonitoringActionAllowed']),

        itemStateVisible() {
            return this.userRole !== 'webo_user' || (this.userRole === 'webo_user' && this.getUserAccess({ type: 'monitoring_access' }) !== 'none')
        },
        sharedAccountsList() {
            return this.sharedAudiences[this.audienceSelectedId]
        },
        disableInput() {
            return this.isProcessing || (this.userRole === 'webo_user' && this.getUserAccess({ type: 'monitoring_access' }) === 'read')
        },
        sharingIsUpToDate() {
            if (!this.sharedAccountsList) return false
            return this.sharedAccountsList.length === this.sharingSettings.audiences.filter(item => item.audience_sharing === 'active').length
        }
    },

    methods: {
        ...mapActions('data/sharedAudience', ['retrieveSharedAudiences', 'createSharedAudience']),
        ...mapMutations('data/sharedAudience', ['setIsProcessing', 'setSharedAccountStatus']),
        ...mapMutations('ui/monitoring', ['setDisplayModal', 'setDeletedSharedAccount']),

        retrieveAudienceSharing() {
            this.retrieveSharedAudiences({ audienceId: this.audienceSelectedId })
        },

        /**
         * Update the value of a sharing between 2 accounts
         * @param {Number} accountId id of the account to which share the audience
         */
        updateValue(accountId, isActive) {
            this.setIsProcessing({ isProcessing: true })
            const sharedAccount = this.sharedAccountsList.filter(item => item.id === accountId)
            if (isActive) {
                this.createSharedAudience({ partnerAccountId: accountId, audienceId: this.audienceSelectedId }).then(() => {
                    this.setIsProcessing({ isProcessing: false })
                })
            } else {
                this.setDisplayModal({ item: 'sharing', display: true })
                this.setDeletedSharedAccount({ sharedAccountId: accountId, sharedAccountLabel: sharedAccount[0].label })
                this.setSharedAccountStatus({ audienceId: this.audienceSelectedId, sharedAccountId: accountId })
            }
        }
    }
}
</script>
